import { type Plugin } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/fr';
import 'dayjs/locale/de';

import { defaultOptions, type SharedPluginOptions } from './sharedPluginOptions';

export const setupDayjs: (options?: Partial<SharedPluginOptions>) => Plugin = (options?: Partial<SharedPluginOptions>) => ({
    install: (): void => {
        dayjs.extend(duration);
        dayjs.extend(isoWeek);
        dayjs.extend(localizedFormat);
        dayjs.extend(utc);
        dayjs.extend(tz);
        dayjs.locale((options?.locale ?? defaultOptions.value.locale).split('-')[0]);

        dayjs.prototype.formatLocale = function(format = 'L'): string {
            return this.locale(dayjs.locale()).format(format);
        };
    }
});